import { useSearchParams } from 'react-router-dom';

export const useShareToken = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get('token') ?? undefined;
};
